module.exports = __webpack_public_path__ + "img/logo.556ef41d.svg";